import ContentLoader from "react-content-loader";

const FormSkeleton = () => {
  return (
    <div style={{ marginTop: "40px" }}>
      <ContentLoader
        speed={2}
        width="100%"
        height={380}
        viewBox="0 0 1000 380"
        // backgroundColor="#f3f3f3"
        // foregroundColor="#ecebeb"
        backgroundColor="#e7cece"
        foregroundColor="#ebeceb"
      >
        {/* Heading */}
        <rect x="20" y="10" rx="4" ry="4" width="300" height="25" />

        {/* Row 1 */}
        <rect x="20" y="60" rx="4" ry="4" width="200" height="15" />
        <rect x="20" y="80" rx="6" ry="6" width="450" height="40" />

        <rect x="520" y="60" rx="4" ry="4" width="200" height="15" />
        <rect x="520" y="80" rx="6" ry="6" width="450" height="40" />

        {/* Row 2 */}
        <rect x="20" y="140" rx="4" ry="4" width="200" height="15" />
        <rect x="20" y="160" rx="6" ry="6" width="450" height="40" />

        <rect x="520" y="140" rx="4" ry="4" width="200" height="15" />
        <rect x="520" y="160" rx="6" ry="6" width="450" height="40" />

        {/* Row 3 - Full Width */}
        <rect x="20" y="220" rx="4" ry="4" width="200" height="15" />
        <rect x="20" y="240" rx="6" ry="6" width="450" height="40" />

        {/* Buttons - LEFT SIDE */}
        <rect x="20" y="310" rx="6" ry="6" width="120" height="40" />
        <rect x="160" y="310" rx="6" ry="6" width="120" height="40" />
      </ContentLoader>
    </div>
  );
};

export default FormSkeleton;
